
























































































































import { Component, Provide, Vue } from 'vue-property-decorator'
import { TypeformResponseAPI } from '@/api/backend-client'
import { TypeformResponse } from '@/api/model/typeform/typeform-response'

@Component
export default class TypeformResponsesList extends Vue {
    loading: boolean = false
    responses: TypeformResponse[] = []
    totalItems: number = 0
    totalPages: number = 0
    page: number = 1
    itemsPerPage: number = 10
    orderField: string = 'submittedAt'
    orderDirection: string = 'desc'

    async created(): Promise<void> {
        await this.reload()
    }

    @Provide()
    async reload(): Promise<void> {
        this.loading = true

        const params = {
            pagination: true,
            page: this.page,
            itemsPerPage: this.itemsPerPage,
            company: this.$currentCompany.id,
        }

        if (this.orderField && this.orderDirection) {
            params[`order[${this.orderField}]`] = this.orderDirection
        }

        const result = await TypeformResponseAPI.getPaged(params)
        this.responses = result.collection
        this.totalItems = result.totalItems
        this.totalPages = result.totalPages

        this.loading = false
    }

    changeOrder(field: string, direction: string) {
        if (this.orderField === field) {
            direction = this.orderDirection === 'asc' ? 'desc' : 'asc'
        } else {
            direction = 'desc'
        }

        this.orderField = field
        this.orderDirection = direction

        this.reload()
    }

    generateHeaderClasses(field: string) {
        return {
            'sortable': true,
            'sorted': this.orderField === field,
            'sorted--asc': this.orderField === field && this.orderDirection === 'asc',
            'sorted--desc': this.orderField === field && this.orderDirection === 'desc',
        }
    }

    async nextPage(): Promise<void> {
        this.page++
        await this.reload()
    }

    async prevPage(): Promise<void> {
        this.page--
        await this.reload()
    }

    relatieNaam(relatie: any): string {
        let voornaam = relatie.roepnaam
        if (!voornaam) {
            voornaam = (relatie.titel + ' ' + relatie.initialen).trim()
        }

        return [voornaam, relatie.tussenvoegsel, relatie.achternaam]
            .filter(value => value !== null && value !== '')
            .join(' ')
    }

    wonenObjectAdres(wonenObject: any): string {
        let address = ''

        if (wonenObject.adres.straat && wonenObject.adres.straat.length > 0) {
            address = address.trim()
            address += ` ${wonenObject.adres.straat}`
        }

        if (wonenObject.adres.huisnummer && wonenObject.adres.huisnummer.length > 0) {
            address = address.trim()
            address += ` ${wonenObject.adres.huisnummer}`
        }

        if (wonenObject.adres.huisnummertoevoeging && wonenObject.adres.huisnummertoevoeging.length > 0) {
            address = address.trim()
            address += ` ${wonenObject.adres.huisnummertoevoeging}`
        }

        if (wonenObject.adres.plaats && wonenObject.adres.plaats.length > 0) {
            address = address.trim()
            address += `, ${wonenObject.adres.plaats}`
        }

        return address
    }

    async goToDetail(response: TypeformResponse): Promise<void> {
        await this.$router.push({
            name: 'typeform_responses_detail',
            params: {
                responseId: response.id,
            },
        })
    }

}
